var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.eventType === 'sign')?_c('div',{staticClass:"event-one"},_vm._l((_vm.eventList),function(item,index){return _c('ActiveCard',{key:index,attrs:{"data":item,"roomId":parseInt(_vm.roomId)}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }